import { capitalize } from 'vue';

import TableColumnTypes from '@/common/components/controls/table/TableColumnTypes';
import EntityProperty from '@/common/models/EntityProperty';
import GeofenceGroup from '@/common/models/geo/GeofenceGroup';
import rootStore from '@/store';
import { UPDATE_GEOFENCE_GROUP_DESCRIPTION, UPDATE_GEOFENCE_GROUP_NAME } from '@/store/modules/models/mutation-types';
import i18n from '@/vueI18n';

export const getEntityProperties = () => {
  const type = 'GeofenceGroup';

  const action = (gg) => rootStore.dispatch('orgApp/updateGeofenceGroup', { instance: gg, showLoader: false });

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const getExtraValidation = (gg: GeofenceGroup) => {
    const extras = {};
    return extras;
  };

  GeofenceGroup.entityPropertiesCached = {
    id: new EntityProperty({
      label: '#',
      property: 'geofencegroup_id',
      type: TableColumnTypes.string,
      editablePropertyName: 'id',
    }),
    name: new EntityProperty({
      label: capitalize(i18n.global.t('names.name')),
      property: 'name',
      type: TableColumnTypes.string,
      editablePropertyName: 'name',
      mutation: UPDATE_GEOFENCE_GROUP_NAME,
      editableClassName: type,
      action,
      getExtraValidation,
    }),
    description: new EntityProperty({
      label: capitalize(i18n.global.t('names.description')),
      property: 'description',
      type: TableColumnTypes.string,
      editablePropertyName: 'description',
      mutation: UPDATE_GEOFENCE_GROUP_DESCRIPTION,
      editableClassName: type,
      action,
      getExtraValidation,
    }),
    geofencesCount: new EntityProperty({
      label: capitalize(i18n.global.t('names.geofence', { n: 2 })),
      property: 'geofencesCount',
      type: TableColumnTypes.string,
    }),
  };
  return GeofenceGroup.entityPropertiesCached;
};
